import { render, staticRenderFns } from "./AtonsLayer.vue?vue&type=template&id=036c102a&"
import script from "./AtonsLayer.vue?vue&type=script&lang=ts&"
export * from "./AtonsLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports